import React, { useCallback } from "react";
import {
  selectUsersVariables,
  selectUsersXVariables,
} from "../users-selectors";
import {
  FormControlLabel,
  List,
  ListItemText,
  Paper,
  Stack,
  Switch,
} from "@mui/material";
import { Body1, H6 } from "../../../../components";
import { useDispatch, useSelector } from "react-redux";
import {
  usersXVariablesAdd,
  usersXVariablesDelete,
} from "../reducers/users-page-actions";

const STR = {
  titleUsersXVariables: "Usuários x Variáveis",
  subtitleUsersXVariables: "Atribuição e retirada de variáveis aos usuários",
};

const varInUser = (userId, varId, usersXVars) => {
  if (!usersXVars.hasOwnProperty(userId)) return false;
  return usersXVars[userId].includes(varId);
};

function UsersXVariables({ id }) {
  const dispatch = useDispatch();
  const vars = useSelector(selectUsersVariables);
  const usersXVars = useSelector(selectUsersXVariables);
  //
  const toggleVarInUser = useCallback(
    (value, varId) => {
      if (value) {
        dispatch(
          usersXVariablesAdd({
            id_usuario: id,
            id_variavel: varId,
          })
        );
      } else {
        dispatch(
          usersXVariablesDelete({
            id_usuario: id,
            id_variavel: varId,
          })
        );
      }
    },
    [dispatch, id]
  );
  return (
    <Stack>
      <H6>{STR.titleUsersXVariables}</H6>
      <Body1 align="center">{STR.subtitleUsersXVariables}</Body1>
      <List disablePadding dense>
        {vars?.map((inVar) => (
          <Paper key={inVar.id} sx={{ p: 0.5, my: 0.5 }}>
            <VariableItem
              name={inVar.nome}
              description={inVar.descricao}
              id={inVar.id}
              onToggle={toggleVarInUser}
              isChecked={
                usersXVars ? varInUser(id, inVar.id, usersXVars) : false
              }
            />
          </Paper>
        ))}
      </List>
    </Stack>
  );
}

const VariableItem = ({ id, name, description, isChecked, onToggle }) => {
  return (
    <FormControlLabel
      checked={isChecked}
      onChange={(e) => onToggle(e.target.checked, id)}
      control={<Switch />}
      label={<ListItemText primary={name} secondary={description} />}
    />
  );
};

export default UsersXVariables;
